import { ColumnsType } from 'antd/es/table';

export const headerFlowReg: ColumnsType<any> = [
  {
    title: 'Mã chi nhánh',
    dataIndex: 'dc_code',
  },
  {
    title: 'Mã cửa hàng',
    dataIndex: 'code',
  },
  {
    title: 'Tên cửa hàng',
    dataIndex: 'name',
  },
  {
    title: 'Trạng thái',
    dataIndex: 'status',
  },
  {
    title: 'Ngày tạo',
    dataIndex: 'created_at',
  },
  {
    title: 'Người tạo',
    dataIndex: 'created_by',
  },
];
